import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

export default function SkeletonAbout() {
  return (
    <SkeletonTheme>
      <div data-name="title">
        <Skeleton height={54} width={380} />
      </div>
      <div data-name="subtitle">
        <Skeleton count={4} height={40} />
      </div>
      <div data-name="box">
        <Skeleton count={9} height={180} width={180} />
      </div>
      <div data-name="footer">
        <Skeleton count={4} height={40} />
      </div>
    </SkeletonTheme>
  );
}